import script from "./Horizontal_setup.vue?vue&type=script&lang=ts&setup=true"
export * from "./Horizontal_setup.vue?vue&type=script&lang=ts&setup=true"

import "./Horizontal_setup.vue?vue&type=style&index=0&id=10be7ce1&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10be7ce1"]])

export default __exports__